import axiosInstance from "../utils/axios";

export const trainingVerificationService = {
  fetchAllPaginate: async (params = {}) => {
    const response = await axiosInstance.get("/training-participant/paginate", {
      params,
    });
    return response.data;
  },
  fetchAll: async (params = {}) => {
    const response = await axiosInstance.get("/training-participant", {
      params,
    });
    return response.data;
  },
  fetchById: async (id) => {
    const response = await axiosInstance.get(`/training-participant/${id}`);
    return response.data;
  },
  changeStatus: async (id, status, reason) => {
    const response = await axiosInstance.post(
      `/training-participant/${id}/status`,
      { status, reason }
    );
    return response.data;
  },
  exportExcel: async (params = {}) => {
    const response = await axiosInstance.get(
      "/training-participant/export-excel",
      {
        params,
        responseType: "blob",
      }
    );
    return response;
  },
};
